import styled, {css, keyframes} from "styled-components";
import {clamp} from "../../../../../common/utils/math-util";
import {wheelBoxShadowInset, wheelBrownBorder, wheelSliceDark, wheelSliceLight} from "../../wheel-color-helper";
import {rotatingWheelSizeInPercentage} from "../../wheel-sizing-helper";

const rotationKeyframes = (degrees: number) => keyframes`
    0% {
        transform: rotate(0deg);
    }
    82% {
        transform: rotate(${degrees + 4}deg);
    }
    92% {
        transform: rotate(${degrees - 2}deg);
    }
    100% {
        transform: rotate(${degrees}deg);
    }
`;

/**
 * Because we have only 2 colors than numberOfSlices must be even number to have nice results
 * TODO: WheelOfJackpotbet: logic here is similar to the pegs positioning
 * @returns string
 */
function generateConicGradient(numberOfSlices: number, sliceColors = [wheelSliceLight, wheelSliceDark]) {
    // TODO: In order to look nice no matter the number of slices, the sliceColors length should divide the number of slices. But there are cases when this is not an issue
    // if (numberOfSlices % sliceColors.length !== 0) {
    //     throw new Error("the sliceColors length must divide the number of slices");
    // }
    const oneSliceDeg = 360 / numberOfSlices; // 45 deg
    const slices = [];
    for (let i = 0; i <= numberOfSlices; i++) {
        const angleStart = clamp(0, (i*2-1)*oneSliceDeg/2, 360);
        const angleEnd = clamp(0, (i*2+1)*oneSliceDeg/2, 360);
        const sliceColor = sliceColors[i % 2];
        slices.push(sliceColor + " " + angleStart + "deg " + angleEnd + "deg")
    }
    return slices.join(", ");
}


export const WheelDefaultBox = styled.div<{numberOfSlices: number; rotated?: boolean; degrees?: number;}>`
    /** This creates a positioning context for all children with position: absolute to be rendered at the center */
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;

    /** Prevents creating scrolls when rotating due to elements overflowing, like those highlighing the winning slice */
    overflow: clip;

    width: ${rotatingWheelSizeInPercentage}%;
    height: ${rotatingWheelSizeInPercentage}%;
    border-radius: 50%;

    border: 1px solid ${wheelBrownBorder};
    box-shadow: inset 0 0 13px ${wheelBoxShadowInset};
    background-color: ${wheelSliceLight};

    background: conic-gradient(${({numberOfSlices}) => generateConicGradient(numberOfSlices)});

    ${({rotated, degrees}) => ((rotated && degrees) ? css`
        animation: ${rotationKeyframes(degrees)} 3s cubic-bezier(0.3, 0.8, 0.8, 1) forwards;
    ` : null) }
`